<template>
  <div class="wdsolutionMain">
        <div class="solttionCon">
          <div class="solttionConItem">
            <div class="solttionConHead">
              <ul>
                <li></li>
                <li>行业痛点</li>
              </ul>
            </div>
            <div class="solutionList">
                <ul v-if="difficultList.length>0">
                  <li v-for="item in difficultList">
                      <div><img :src="item.img"></div>
                      <dl>
                        <dt>{{item.title}}</dt>
                        <dd>{{item.content}}</dd>
                      </dl>
                  </li>
                </ul>
            </div>
          </div>
          <div class="solttionConItem">
            <div class="solttionConpor">
              <div class="solttionConHead">
                <ul>
                  <li></li>
                  <li>解决方案</li>
                </ul>
              </div>
              <div class="programBox">
                <div class="programLeft">
                  <p> 对于网贷行业，可凭借智签电子签约平台签署合法合规的电子合同，同时，通过技术手段的运用，固化实名认证、合同签署、履约执行等整个业务流程中的电子数据并进行存证，保障电子数据的真实性原始性，并利用区块链技术通过司法联盟链将数据同步至多家公证处、司法鉴定机构、仲裁机构以及互联网法院，保证电子数据可以作为证据被法院、仲裁所采信。并将相应的履约条款作为触发条件写入智能合约，满足触发条件后，自动执行。</p>
                  <p>    网贷行业解决方案提供实名认证、电子合同签署、电子数据存证、数据密文托管、在线公证、在线鉴定等多元化的在线服务。为网贷平台的合规建设、风险控制、绿色催收、品牌建设提供有力支撑，从而大幅度降低平台运营风险，加快合规进度，提升企业的核心竞争力。</p>
                </div>
                <div class="programRight">
                  <img src="../../../assets/images/solution/loop.png">
                </div>
              </div>

            </div>
          </div>
           <div class="solttionConItem">
              <div class="solttionConHead">
                <ul>
                  <li></li>
                  <li>特色保障</li>
                </ul>
              </div>
              <div class="guaranteeList">
                <ul>
                  <li v-for="item in guaranteeList">
                    <div>
                        <img :src="item.img" class="BigImg">
                        <span class="icon" v-bind:style="{backgroundImage:'url(' + item.icon + ')'}"></span>
                    </div>
                    <dl>
                      <dt><span>{{item.title}}</span></dt>
                      <dd>{{item.content}}</dd>
                    </dl>
                  </li>
                </ul>
              </div>
           </div>
        </div>
    </div>
</template>
<script>
export default {
  data(){
    return{
      difficultList:[
        {
          img:require("../../../assets/images/solution/offsite_icon.png"),
          title:"异地签署难",
          content:"网贷行业的用户来自于全国各地，合同需要异地签署，成本高，效率低。"
        },
        {
          img:require("../../../assets/images/solution/management_icon.png"),
          title:"合同管理难",
          content:"大量的纸质合同或者电子合同，存储成本高，安全性差，管理困难。"
        },
        {
          img:require("../../../assets/images/solution/dispute_icon.png"),
          title:"纠纷解决难",
          content:"用户来自于全国各地，如果出现借贷纠纷，线下解决困难，耗时长。"
        },
        {
          img:require("../../../assets/images/solution/pressure_icon.png"),
          title:"合规压力大",
          content:"从2016年开始，网贷行业进入监管时代，对电子签名和存证提出了相应的要求。"
        }
      ],
      guaranteeList:[
        {
          img:require("../../../assets/images/solution/legal_img.png"),
          icon:require('../../../assets/images/solution/legal_nor_icon.png.png'),
          title:"法律效力",
          content:"对接公安部、工商局、银联数据库进行实名认证，保障合同主体可信，采用数字证书，可信时间源等方式，保障合同司法效力。"
        },
        {
          img:require("../../../assets/images/solution/signcontrol_img.png"),
          icon:require('../../../assets/images/solution/signcontrol_pre_icon.png.png'),
          title:"签控一体",
          content:"签约、履约等全证据链全部通过司法联盟链进行存证，通过智能合约进行履约管控，控制违约风险，保障签约方的合法权益。"
        },
        {
          img:require("../../../assets/images/solution/judicial_img.png"),
          icon:require('../../../assets/images/solution//judicial_nor_icon.png'),
          title:"司法保障",
          content:"司法联盟链同步至多家公证处、司法鉴定机构，仲裁机构以及互联网法院，多方参与共识，保证电子数据作为证据的司法证明能力。"
        },
        {
          img:require("../../../assets/images/solution/data_img.png"),
          icon:require('../../../assets/images/solution/data_nor_icon.png.png'),
          title:"数据安全",
          content:"采用杂凑算法、非对称加密算法、分布式存储、区块链技术等多种技术保障电子数据的真实性、安全性及不可篡改。"
        },
      ],
    }
  }
}
</script>
<style lang="scss" >
.wdsolutionMain{
    width:100%;
    .solttionCon{
      .solttionConItem{
        width:1180px;
      padding-bottom:40px;
       margin:0 auto;
        .solttionConHead{
          width: 100%;
          overflow: hidden;
          padding-top: 40px;
          padding-bottom: 30px;
          li{
            float: left;
            line-height: 18px;
          }
          li:nth-child(1){
            height: 18px;
            width:4px;
            background: #B41C2E;
            margin-right: 10px;
          }
          li:nth-child(2){
            font-family: 'PingFangSC-Light';
            font-size: 18px;
            color: #464646;
          }
        }
        .solutionList{
          width:100%;
          height: 190px;
          li{
            width: calc((100% - 60px) / 4);
            height: 190px;
            float: left;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            margin-right: 20px;
            padding:20px;
            box-sizing: border-box;
            border: 1px solid rgb(235,235,235);
            div{
              text-align: right;
              img{
                width:48px;
                height: auto;
              }
            }
            dl{
              dt{
                font-size: 18px;
                color: #464646;
                font-weight: 550;
                margin-bottom: 10px;
              }
              dd{
                font-size: 13px;
                color: #787878;
                line-height: 19px;
                text-align: justify;
              }
            }
          }
          li:last-child{
            margin-right: 0;
          }
          li:hover{
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.20);
             border-color: #fff;
          }
        }
        .programBox{
          width:100%;
          overflow: hidden;
          .programLeft{
            float: left;
            margin-right: 30px;
            width: calc(100% - 499px);
            p{
              font-size: 14px;
              color: #787878;
              text-align: justify;
              line-height: 26px;
              text-indent: 2em;
            }
            p:last-child{
              margin-top:20px;
            }
          }
          .programRight{
            width:468px;
            float: left;
            img{
              width:100%;
              height: auto;
            }
          }
        }
        .solttionConpor{
          max-width: 1180px;
          margin:0 auto;
        }
        .guaranteeList{
          width:100%;
          height: 328px;
          li{
            width: calc((100% - 78px) / 4);
            height: 328px;
            float: left;
            margin-right: 26px;
            box-sizing: border-box;
            padding:2px;
            border: 1px solid rgb(235,235,235);
            div{
              width:100%;
              height: 160px;
              position: relative;
              .BigImg{
                width:100%;
                height: 100%;
              }
              .icon{  
                position: absolute;
                top:50%;
                left:50%;
                margin-top:-19px;
                margin-left: -20px;
                width:40px;
                height: 38px;
                background-size:100% 100%;
              }
            }
            dl{
              dt{
                font-size: 18px;
                color: #464646;
                font-weight: 550;
                margin-top:11px;
                margin-bottom: 15px;
                text-align: center;
                span{
                  display: inline-block;
                  padding-bottom: 6px;
                  border-bottom: 2px solid #B4B4B4;
                }
              }
              dd{
                box-sizing: border-box;
                padding:0 16px;
                font-size: 14px;
                color: #787878;
                line-height: 21px;
                text-align: justify;
              }
            }
          }
          li:last-child{
            margin-right: 0;
          }
          li:hover{
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.20);
            border-color: #fff;
            dl dt span{
              border-color:#686868;
            }
          }
          li:nth-child(1):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/legal_hov_icon.png')!important;
            }
          }
          li:nth-child(2):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/signcontrol_hov_icon.png')!important;
            }
          }
          li:nth-child(3):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/judicial_hov_icon.png.png')!important;
            }
          }
          li:nth-child(4):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/data_hov_icon.png')!important;
            }
          }
        }
      }
      .solttionConItem:nth-child(2){
        width: 100%;
        background: #F3F2F2;
      }
    }
  }
</style>
